module.exports = __webpack_public_path__ + "img/tag_not_started.77639cc8.png";